module.exports = __webpack_public_path__ + "img/popup-3.1448fc2f.jpg";